const breadcrumbFolderRecent = (breadcrumb = [], action) => {
    switch (action.type) {
      case "SET_BREADCRUMB_FOLDER_RECENT":
        return action.breadcrumb
      default:
        return breadcrumb;
    }
  };
export default breadcrumbFolderRecent;
  